export const financialSteps = [
  {
    target: '#start-item',
    content: 'Nesta página, Você visualiza dados de pagamento das diligências.',
    disableBeacon: true,
  },
  {
    target: '#left-filter',
    content: 'Usando o filtro à esquerda, você pode filtrar seu relatório por diversos critérios.',
  },
  {
    target: '#payment-status',
    content:
      'O status do pagamento pode ser aterado clicando em "Aguardando pagamento" e anexando o comprovante.',
  },
];
